import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import "../index.css"

/**
 * [CustomizedRating description]
 * @param {[string]} theme [The theme of the component - default: light]
 * @param {[string]} styleVariant [Used to represent colored interface elements for a user - default: primary]
 * @param {[any]} ...props [Other valid props for MUI Rating]
 * @returns {[object]} [Returns the Rating component]
 */
const CustomizedRating = (props) => {
  const { theme = "light", styleVariant = "primary", ...remaining } = props;
  const StyledRating = styled(Rating)({
    "& .MuiRating-iconFilled": {
      color: `var(--${styleVariant}-rating-bgcolor-${theme})`,
    },
    "& .MuiRating-iconHover": {
      color: "#e4e4e4",
    },
  });
  return <StyledRating {...remaining} />;
};

CustomizedRating.propTypes = {
  theme: PropTypes.oneOf(["light", "dark"]),
  styleVariant: PropTypes.oneOf(["primary", "secondary"]),
};

export default CustomizedRating;
